import { cn } from '@/lib/cn';

export function TrainerCard({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <div className={cn('rounded-[24px] border border-[#ececec] bg-white drop-shadow-[0px_1px_2px_rgba(0,0,0,0.04)]', className)}>
      {children}
    </div>
  );
}
